var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.badge.id > 0)?_c('div',{staticClass:"checkbox-group"},[_c('div',{staticClass:"checkbox-left"},[_c('switches',{attrs:{"enabled":_vm.saleOnlyHere,"value":"sale_only_here"},on:{"input":_vm.setValue}}),_vm._v(" "),_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.__( 'Exclusive to Platform', 'dokan' )))])],1)]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }